import { useState } from "react";
import API from "../api/api";
import toast from "react-hot-toast";

export default function Checkout() {
  const [id, setId] = useState("");

  const handleCheckout = async () => {
    try {
      await API.patch(`/checkout/${id}`, {
        status: "CHECKED_OUT"
      });

      toast.success("Uitchecken gelukt");
    } catch {
      toast.error("Uitchecken mislukt");
    }
  };

  return (
    <section className="page">
      <header className="page-header">
        <div>
          <h1 className="page-title">Uitchecken</h1>
          <p className="page-subtitle">Markeer een reservatie als uitgecheckt.</p>
        </div>
      </header>

      <div className="panel panel-pad action-card">
        <div className="form-grid">
          <input
            className="input"
            placeholder="Reservatie ID"
            onChange={(e) => setId(e.target.value)}
          />

          <button className="button" onClick={handleCheckout}>
            Trailer uitchecken
          </button>
        </div>
      </div>
    </section>
  );
}
